/** True when the SPA is running inside the Microsoft Teams host. */
export function isRunningInTeams(): boolean {
  return sessionStorage['isUsingTeams'] === 'true';
}
